import React from 'react';
import CheckboxMultiSelectFilter from 'components/DataGrid/Filter/CheckboxMultiSelectFilter';
import ProductionTagsFilter from 'components/ProductionTagsFilter/ProductionTagsFilter';

import { SHOP_SALE_OFFERS, getShopSaleLabels } from './shopSaleColumnHelpers';

const extractComponents = (components, ingredientFieldName = 'name') =>
  components
    .map(component => {
      if (component.ingredient) {
        return component.ingredient[ingredientFieldName] || false;
      }
      if (component.recipe) {
        if (component.recipe.ingredients.length > 0) {
          return `${component.recipe.workName}(${extractComponents(
            component.recipe.ingredients,
            ingredientFieldName
          )})`;
        }
        return component.recipe.workName || false;
      }

      return false;
    })
    .filter(Boolean)
    .join(', ');

const columnConfig = [
  {
    title: 'ID',
    accessor: 'id',
    name: 'id',
    filterable: true,
    width: 50,
  },
  {
    title: 'form.field.nameForClient',
    name: 'nameForClient',
    accessor: 'nameForClient',
    filterable: true,
  },
  {
    title: 'form.field.workingName',
    name: 'workingName',
    accessor: 'workingName',
    filterable: true,
  },
  {
    title: 'form.field.ingredientNamesForClient',
    name: 'ingredientName',
    accessor: row => extractComponents(row.components),
    filterable: true,
    sortable: false,
  },
  {
    title: 'form.field.ingredientWorkingNames',
    name: 'ingredientWorkingName',
    accessor: row => extractComponents(row.components, 'workName'),
    filterable: true,
    sortable: false,
  },
  {
    title: 'form.field.mealTypes',
    name: 'types',
    accessor: row => row.types.map(type => type.name).join(', '),
    filterable: true,
    sortable: false,
  },
  {
    title: 'form.field.shopSale',
    name: 'shopSale',
    accessor: (row, { t }) => getShopSaleLabels(row, t),
    filterable: true,
    sortable: false,
    extractFiltersByComma: false,
    wrapFilter: true,
    Filter: ({ onChange, filter }, { t }) => (
      <CheckboxMultiSelectFilter
        options={SHOP_SALE_OFFERS.map(({ value, translationKey }) => ({
          value,
          label: t(translationKey),
        }))}
        value={filter?.value ?? []}
        onChange={onChange}
        menuWidth={220}
      />
    ),
  },
  {
    title: 'form.field.shopCategories',
    name: 'categories',
    accessor: row =>
      (row.categories || []).map(category => category.name).join(', '),
    filterable: true,
    sortable: false,
  },
  {
    title: 'form.field.tags',
    name: 'tags',
    accessor: row => row.tags.map(tag => tag.value).join(', '),
    filterable: true,
    sortable: false,
    Filter: ProductionTagsFilter,
  },
  {
    title: 'form.field.rateAVG',
    name: 'rate',
    accessor: row => (row?.rateAVG ? parseFloat(row.rateAVG).toFixed(2) : null),
    filterable: true,
    sortable: true,
  },
];

export default columnConfig;
